import React from 'react';
import {observer} from 'mobx-react';
import {PreviousMeetingsWidgetProps} from "../models/previous-meetings-widget.props";
import {PreviousMeetingsWidgetUsLayoutPartialGameViewModel} from "../models/previous-meetings-widget.us-layout.partial-game.view-model";
import {PreviousMeetingsWidgetMatchRowOdds} from "./previous-meetings-widget.match-row-odds";

export class PreviousMeetingsWidgetMatchRowBottomProps extends PreviousMeetingsWidgetProps {
  item: PreviousMeetingsWidgetUsLayoutPartialGameViewModel;
}

export const PreviousMeetingsWidgetMatchRowBottom = observer(({controller, item, shouldRenderOdds}: PreviousMeetingsWidgetMatchRowBottomProps) => {
  return (shouldRenderOdds ? <PreviousMeetingsWidgetMatchRowOdds controller={controller} item={item}/> :
    null
  )
});
